interface GenerateSectionProps {
  onGenerate: () => void;
  disabled: boolean;
}

export default function GenerateSection({ onGenerate, disabled }: GenerateSectionProps) {
  return (
    <section className="bg-gradient-to-r from-indigo-600 to-purple-600 rounded-xl p-8 text-center">
      <div className="max-w-2xl mx-auto">
        <div className={`w-16 h-16 flex items-center justify-center mx-auto mb-4 rounded-full transition-all ${
          disabled ? 'bg-white/10' : 'bg-white/20'
        }`}>
          <i className={`ri-magic-line text-3xl ${disabled ? 'text-white/40' : 'text-white'}`}></i>
        </div>

        <h2 className={`text-2xl font-bold mb-3 ${disabled ? 'text-white/50' : 'text-white'}`}>
          Generar Listas
        </h2>

        {disabled ? (
          <p className="text-indigo-200/60 mb-6 text-sm">
            Cargá un archivo Excel primero para habilitar la generación de listas
          </p>
        ) : (
          <p className="text-indigo-100 mb-6 text-sm">
            Hacé clic para configurar la cantidad por lista y generar aleatoriamente
          </p>
        )}

        <button
          type="button"
          onClick={disabled ? undefined : onGenerate}
          disabled={disabled}
          className={`inline-flex items-center gap-3 px-8 py-4 text-base font-bold rounded-xl transition-all whitespace-nowrap ${
            disabled
              ? 'bg-white/20 text-white/40 cursor-not-allowed'
              : 'bg-white text-indigo-600 hover:bg-indigo-50 hover:scale-105 cursor-pointer shadow-xl'
          }`}
        >
          <i className="ri-play-circle-line text-xl"></i>
          Generar Listas Aleatorias
        </button>

        {!disabled && (
          <div className="mt-6 flex items-center justify-center gap-6 text-white/80 text-xs">
            <div className="flex items-center gap-2">
              <i className="ri-shield-check-line text-base"></i>
              <span>Distribución aleatoria</span>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-group-line text-base"></i>
              <span>Evita clubes repetidos</span>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-sliders-2-line text-base"></i>
              <span>Cantidad configurable</span>
            </div>
          </div>
        )}

        {disabled && (
          <div className="mt-6 flex items-center justify-center gap-2 text-white/40 text-xs">
            <i className="ri-arrow-up-line text-sm"></i>
            <span>Subí tu archivo para continuar</span>
          </div>
        )}
      </div>
    </section>
  );
}
